'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosMedicalOutline = function IoIosMedicalOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.4 14.7l-9.2 5.3 9.2 5.3-2.5 4.4-9.2-5.4v10.7h-5v-10.7l-9.2 5.4-2.5-4.4 9.2-5.3-9.2-5.3 2.5-4.4 9.2 5.4v-10.7h5v10.7l9.2-5.4z m-1.7 11.1l-10-5.8 10-5.8-1.2-2.2-10 5.8v-11.5h-2.5v11.5l-10-5.8-1.3 2.2 10 5.8-10 5.8 1.3 2.2 10-5.8v11.6h2.5v-11.6l10 5.8z' })
        )
    );
};

exports.default = IoIosMedicalOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-medical-outline.js
// module id = 2232
// module chunks = 0